import { Message } from 'element-ui';
import service from './index';

const ERR_OK = 10000;
const defaultOptions = {
  error: true,
};

function request(url, params, options, method) {
  options = {
    ...defaultOptions,
    ...options,
  };
  return new Promise((resolve, reject) => {
    let data = {};

    if (method === 'get') {
      data = {
        params,
      };
    } else {
      data = {
        data: params,
      };
    }
    // http开头的默认为外网URL
    const thirdUrl = url.toLocaleLowerCase().startsWith('http');
    if (thirdUrl) {
      data.baseURL = '';
    }
    const serviceParams = {
      url,
      method,
      retry: options.retry,
      ...data,
    };
    service(serviceParams)
      .then((res) => {
        if (res.code === ERR_OK || thirdUrl) {
          resolve(res.data);
        } else {
          if (options.error && res && res.code !== 401) {
            Message.error(res.msg);
          }
          reject(res);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  });
}

export const get = (url, params = {}, options) => {
  Object.keys(params).forEach((key) => {
    if (params[key] === '' || params[key] === undefined || params[key] === null) {
      delete params[key];
    } else if (typeof params[key] === 'object') {
      params[key] = JSON.stringify(params[key]);
    }
  });
  return request(url, params, options, 'get');
};
export const post = (url, params, options = {}) => {
  let _params = {
    ...params,
  };
  if (options.contentType === 'formData') {
    const formData = new FormData();
    Object.keys(params).forEach((key) => {
      formData.append(key, JSON.stringify(params[key]));
    });
    _params = formData;
  }
  return request(url, _params, options, 'post');
};
export const put = (url, params, options) => {
  return request(url, params, options, 'put');
};
export const del = (url, params, options) => {
  return request(url, params, options, 'delete');
};
